export default __webpack_public_path__ + "static/media/sticker-F.f1848f68.png";